import { useMediaQuery } from 'react-responsive';

const MobileSm = ({ children }) => {
  const isMobileSm = useMediaQuery({ maxWidth: 575 });
  return isMobileSm ? children : null;
};

export default MobileSm;
